import { useState } from 'react'
import { CartDrawer } from '../CartDrawer'
import { useCartContext } from '../../context'
import styles from './Header.module.css'

export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const { itemCount, isCartOpen, openCart, closeCart } = useCartContext()

  return (
    <>
      <header className={styles.header}>
        <div className={styles.container}>
          <a href="#" className={styles.logo} aria-label="Tortu-k — Inicio">
            <span className={styles.logoText}>Tortu-k</span>
            <div className={styles.logoDot} aria-hidden="true">
              <span style={{ background: 'var(--color-cover-red)'    }} />
              <span style={{ background: 'var(--color-cover-yellow)' }} />
              <span style={{ background: 'var(--color-cover-green)'  }} />
              <span style={{ background: 'var(--color-cover-blue)'   }} />
            </div>
          </a>

          <button
            type="button"
            className={styles.menuToggle}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-expanded={isMenuOpen}
            aria-controls="main-nav"
            aria-label={isMenuOpen ? 'Cerrar menú' : 'Abrir menú'}
          >
            <span className={styles.menuIcon} />
          </button>

          <nav
            id="main-nav"
            className={`${styles.nav} ${isMenuOpen ? styles.navOpen : ''}`}
            aria-label="Navegación principal"
          >
            <ul className={styles.navList}>
              <li>
                <a href="#products" className={styles.navLink}>Colección</a>
              </li>
              <li>
                <a href="#try-on" className={styles.navLink}>Prueba Virtual</a>
              </li>
              <li>
                <a href="#customize" className={styles.navLink}>Configura</a>
              </li>
            </ul>
          </nav>

          <div className={styles.actions}>
            <button
              type="button"
              className={styles.cartButton}
              onClick={openCart}
              aria-label={`Abrir carrito (${itemCount} ${itemCount === 1 ? 'artículo' : 'artículos'})`}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                aria-hidden="true"
              >
                <circle cx="9" cy="21" r="1" />
                <circle cx="20" cy="21" r="1" />
                <path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6" />
              </svg>
              {itemCount > 0 && (
                <span className={styles.cartBadge} aria-hidden="true">
                  {itemCount}
                </span>
              )}
            </button>
          </div>
        </div>
      </header>

      <CartDrawer isOpen={isCartOpen} onClose={closeCart} />
    </>
  )
}
